// export default Jury;
import React from 'react';
import './Jury.css';
import content from '../../config/content';

const Jury = () => {
  return (
    <div className="jury">
      <div className="jury-title">
        <h2>The Jury</h2>
      </div>
      <div className="jury-grid">
        {content.juryMembers.map((member, index) => (
          <div key={index} className="jury-item">
            <img
              src={process.env.PUBLIC_URL + member.image}
              alt={`Jury Member ${index + 1}`}
              className="jury-image"
            />
            <p className="jury-caption">{member.caption}</p>
            {member.description && (
              <p className="jury-description">{member.description}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Jury;
